import * as React from 'react';

const SvgReports = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.12}
      d="M1.95703 5.2C1.95703 4.0799 1.95703 3.51984 2.17035 3.09202C2.35798 2.71569 2.65739 2.40973 3.02565 2.21799C3.44431 2 3.99236 2 5.08846 2H10.5685C11.6646 2 12.2126 2 12.6313 2.21799C12.9995 2.40973 13.2989 2.71569 13.4866 3.09202C13.6999 3.51984 13.6999 4.0799 13.6999 5.2V10.8C13.6999 11.9201 13.6999 12.4802 13.4866 12.908C13.2989 13.2843 12.9995 13.5903 12.6313 13.782C12.2126 14 11.6646 14 10.5685 14H5.08846C3.99236 14 3.44431 14 3.02565 13.782C2.65739 13.5903 2.35798 13.2843 2.17035 12.908C1.95703 12.4802 1.95703 11.9201 1.95703 10.8V5.2Z"
      fill="#0E0C0F"
    />
    <path
      d="M11.0904 6L7.54512 9.62288C7.41594 9.75488 7.35135 9.82088 7.27688 9.84561C7.21136 9.86737 7.14079 9.86737 7.07528 9.84561C7.0008 9.82088 6.93621 9.75488 6.80704 9.62288L5.58798 8.37712C5.4588 8.24512 5.39421 8.17912 5.31973 8.15439C5.25422 8.13263 5.18365 8.13263 5.11814 8.15439C5.04366 8.17912 4.97907 8.24512 4.84989 8.37712L1.95703 11.3333M11.0904 6H8.48084M11.0904 6V8.66667M5.08846 14H10.5685C11.6646 14 12.2126 14 12.6313 13.782C12.9995 13.5903 13.2989 13.2843 13.4866 12.908C13.6999 12.4802 13.6999 11.9201 13.6999 10.8V5.2C13.6999 4.0799 13.6999 3.51984 13.4866 3.09202C13.2989 2.71569 12.9995 2.40973 12.6313 2.21799C12.2126 2 11.6646 2 10.5685 2H5.08846C3.99236 2 3.44431 2 3.02565 2.21799C2.65739 2.40973 2.35798 2.71569 2.17035 3.09202C1.95703 3.51984 1.95703 4.0799 1.95703 5.2V10.8C1.95703 11.9201 1.95703 12.4802 2.17035 12.908C2.35798 13.2843 2.65739 13.5903 3.02565 13.782C3.44431 14 3.99236 14 5.08846 14Z"
      stroke="#0E0C0F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgReports;
